export default "__VITE_ASSET__BRB1aPko__"